function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from 'react';
import { Overlay, OverlayContent } from "./..";
import { DialogContext } from "./DialogContext";
import { useKeyPress } from 'react-use';
var widthMap = Object.freeze({
  xSmall: {
    // -64px to prevent dialog sticking to edges
    width: 'calc(100% - 64px)',
    maxWidth: '400px'
  },
  small: {
    width: 'calc(100% - 64px)',
    maxWidth: '600px'
  },
  medium: {
    width: 'calc(100% - 64px)',
    maxWidth: '960px'
  },
  large: {
    width: 'calc(100% - 64px)',
    maxWidth: '1280px'
  },
  xLarge: {
    width: 'calc(100% - 64px)',
    maxWidth: '1920px'
  }
});
export var Dialog = function Dialog(_ref) {
  var children = _ref.children,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 'small' : _ref$width,
      sticky = _ref.sticky,
      onDismiss = _ref.onDismiss,
      invertBackdrop = _ref.invertBackdrop,
      _ref$dismissOnBackdro = _ref.dismissOnBackdrop,
      dismissOnBackdrop = _ref$dismissOnBackdro === void 0 ? true : _ref$dismissOnBackdro,
      _ref$dismissOnEscape = _ref.dismissOnEscape,
      dismissOnEscape = _ref$dismissOnEscape === void 0 ? true : _ref$dismissOnEscape,
      isOpen = _ref.isOpen;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      modalRef = _React$useState2[0],
      setModalRef = _React$useState2[1];
  /*
   * store modal ref in state
   */


  var modalContentRef = React.useCallback(function (ref) {
    setModalRef(ref);
  }, []);
  /*
   * Dismiss if escape is pressed
   */

  var _useKeyPress = useKeyPress('Escape'),
      _useKeyPress2 = _slicedToArray(_useKeyPress, 1),
      escape = _useKeyPress2[0];

  React.useEffect(function () {
    if (isOpen && escape && dismissOnEscape && onDismiss) {
      onDismiss();
    }
  }, [escape, dismissOnEscape, onDismiss, isOpen]);

  if (!isOpen) {
    return null;
  }

  var context = {
    sticky: sticky,
    currentRef: modalRef,
    onDismiss: onDismiss
  };
  return /*#__PURE__*/React.createElement(DialogContext.Provider, {
    value: context
  }, /*#__PURE__*/React.createElement(Overlay, {
    invertBackdrop: invertBackdrop,
    onDismiss: onDismiss,
    dismissOnBackdrop: dismissOnBackdrop,
    zIndex: "dialog"
  }, /*#__PURE__*/React.createElement(OverlayContent, _extends({
    ref: modalContentRef
  }, widthMap[width], {
    tabIndex: -1
  }), children)));
};
Dialog.displayName = 'Dialog';